import React, { useState, useContext, useEffect } from 'react'
import { store } from '../../store'
import Swal from 'sweetalert2'
import { PASSLIST_ADD } from '../../store/constants'
import { FireAddPassword, FireUpdatePass } from '../../hooks/firebaseFirestore'

function AddPass(props) {
    const firestoreAddPass = FireAddPassword()
    const firestoreUpdatePass = FireUpdatePass()
    const [widget, setWidget] = useState(false)
    const [typePass, setTypePass] = useState('password')
    const [url, setUrl] = useState('')
    const [urlStatus, setUrlStatus] = useState(false)
    const [username, setUsername] = useState('')
    const [password, setPassword] = useState('')
    const [id, setId] = useState(undefined)
    const { state, dispatch } = useContext(store)
    const { passwordManagement } = state
    const { email } = state.user

    const [validateUppercase, setUppercaseVal ] = useState(false)
    const [validateLowercase, setLowercaseVal ] = useState(false)
    const [validateNumber, setNumberVal ] = useState(false)
    const [validateSpecialCharacter, setSpecialCharVal ] = useState(false)
    const [validateLenght, setLenghtVal ] = useState(false)

    const widgetHandle = () => {
        widget ? setWidget(false) : setWidget(true)
        typePass === 'password' ? setTypePass('text') : setTypePass('password')
    }

    useEffect(()=>{
        // eslint-disable-next-line
        let uppercase =  /[A-Z]/.test(String(password))
        let lowercase =  /[a-z]/.test(String(password))
        let number =  /[0-9]/.test(String(password))
        let character =  /[^a-zA-Z0-9\-/]/.test(String(password))
        let length =  String(password).length >= 5
        uppercase === false ? setUppercaseVal(false) : setUppercaseVal(true)
        lowercase === false ? setLowercaseVal(false) : setLowercaseVal(true)
        number === false ? setNumberVal(false) : setNumberVal(true)
        character === false ? setSpecialCharVal(false) : setSpecialCharVal(true)
        length === false ? setLenghtVal(false) : setLenghtVal(true)
    },[password])

    useEffect(()=>{
        // eslint-disable-next-line
        if (passwordManagement.pass) {
            setUrl(passwordManagement.pass[0].url)
            setUsername(passwordManagement.pass[0].username)
            setPassword(passwordManagement.pass[0].password)
            setId(passwordManagement.pass[0].id)
            dispatch({
                type: 'PASSLIST_NONE'
            })
        }
    },[passwordManagement.pass, dispatch])

    const handleUrl = e => { 
        const urlTest = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi;
        const regex = new RegExp(urlTest);
        e.target.value.match(regex) ? setUrlStatus(false) : setUrlStatus(true)
        setUrl(e.target.value)
    }

    const handleUsername = e => { setUsername(e.target.value) }

    const handlePassword = e => { setPassword(e.target.value) }
    

    function launchSwal(message){
        Swal.fire({
            toast: true,
            position: "top",
            title: 'ALERT!',
            text: message,
            timer: 2500,
            imageAlt: 'Custom image',
            showConfirmButton: false,
            showCancelButton: false,
            confirmButtonText: 'نعم',
            cancelButtonText: 'لا',
        })
    }

    const changePassList = () => {
        const modal = document.getElementById('exampleModalCenter');
        const modalBackdrops = document.getElementsByClassName('modal-backdrop');
        modal.classList.remove('show')
        modal.setAttribute('aria-hidden', 'true');
        modal.setAttribute('style', 'display: none');
        if (localStorage.getItem('account')) {
            document.body.removeChild(modalBackdrops[0]);
        }
        dispatch({
            type: PASSLIST_ADD
        })
        setUrl('')
        setUsername('')
        setPassword('')
        setId('')
        setUppercaseVal(false) 
        setLowercaseVal(false) 
        setNumberVal(false)
        setSpecialCharVal(false)
        setLenghtVal(false)
        setWidget(false)
        setTypePass('password')
    }

    const checkValue = (url, username, password) => {
        if (url === '') {
            launchSwal('Url Is Required!')
        } else if (username === '') {
            launchSwal('Username Is Required!')
        } else if (password === '') {
            launchSwal('Password Is Required!')
        } else {
            Swal.showLoading()
            return true
        }
    }

    const fireAddPass = () => {
        if (checkValue(url, username, password)) {        
            dispatch({
                type: "PASSLIST_LOADING",
                status: true
            })
            let emailTemp;
            email ? emailTemp = email : emailTemp = localStorage.getItem('account')
            firestoreAddPass(url, username, password, emailTemp)
                .then(_ => {
                    changePassList()
                    Swal.close()
                })
                .catch(err => { console.log(err); })
        }
    }

    const fireUpdatePass = () => {
        if (checkValue(url, username, password)) {            
            dispatch({
                type: "PASSLIST_LOADING",
                status: true
            })
            const pass = passwordManagement.collections.filter(pass=>{
                return pass.id === id
            })
            let newPass = {
                id : pass[0].id,
                url : url,
                username : username,
                password : password,
                createdAt : pass[0].createdAt,
                updatedAt : Date.now()
            }
            let updatefix = []
            passwordManagement.collections.forEach(pass=>{
                if (pass.id === id) {
                    updatefix.push(newPass)
                } else {
                    updatefix.push(pass)
                }
            })
            let emailTemp;
            email ? emailTemp = email : emailTemp = localStorage.getItem('account')
            firestoreUpdatePass(updatefix, emailTemp)
                .then(_ => {
                    changePassList()
                    Swal.close()
                })
                .catch(err => { console.log(err); })
        }
    }

    return (
        <div>
            {
                props.action === 'update' ?
                <button type="button" className="btn btn-light btn-sm px-2" data-toggle="modal" data-target="#exampleModalCenter">
                    <i className="fas fa-edit"></i>
                </button>
                :
                <button type="button" className="btn btn-success ml-3" data-toggle="modal" data-target="#exampleModalCenter">
                    <i className="fas fa-plus-circle mr-2"></i>
                    AddPassword
                </button>
            }
            <div className="modal fade" id="exampleModalCenter" data-backdrop="static" tabIndex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalCenterTitle">Manage Your Password</h5>
                            <button type="button" onClick={ changePassList } className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            {
                                !url &&
                                <div data-testid="urlAlert-test" className="alert alert-danger alert-dismissible fade show py-1 my-0" role="alert">
                                    <strong> Url </strong> required!
                                </div>
                            }
                            {
                                url && urlStatus &&
                                <div className="alert alert-warning alert-dismissible fade show py-1 my-0" role="alert">
                                    <strong> { url } </strong> Is Not Url
                                </div>
                            }
                            <div className="input-group mb-3">
                                <div className="input-group-prepend">
                                    <span className="input-group-text" id="basic-addon1">URL</span>
                                </div>
                                <input data-testid="urlInput-test" type="text" className="form-control" value={ passwordManagement.pass ? passwordManagement.pass[0].url : url } onChange={ handleUrl } placeholder="http://hacktiv8.com/" aria-label="url" aria-describedby="basic-addon1" />
                            </div>
                            {
                                !username &&
                                <div data-testid="usernameAlert-test" className="alert alert-danger alert-dismissible fade show py-1 my-0" role="alert">
                                    <strong> Username </strong> required!
                                </div>
                            }
                            <div className="input-group mb-3">
                                <div className="input-group-prepend">
                                    <span className="input-group-text" id="basic-addon1">Username</span>
                                </div>
                                <input data-testid="usernameInput-test" type="text" className="form-control" value={ passwordManagement.pass ? passwordManagement.pass[0].username : username } onChange={ handleUsername } placeholder="Your Username" aria-label="username" aria-describedby="basic-addon1" />
                            </div>
                            {
                                !password &&
                                <div data-testid="passwordAlert-test" className="alert alert-danger alert-dismissible fade show py-1 my-0" role="alert">
                                    <strong> Password </strong> required!
                                </div>
                            }
                            <div className="input-group mb-3">
                                <div className="input-group-prepend">
                                    <span className="input-group-text" id="basic-addon1">Password</span>
                                </div>
                                <input data-testid="passwordInput-test" type={ typePass } className="form-control" value={ passwordManagement.pass ? passwordManagement.pass[0].password : password } onChange={ handlePassword } placeholder="Your Password" aria-label="username" aria-describedby="basic-addon1" />
                            </div>
                            {
                                widget ?
                                    <div className="row">
                                        <span> Password Strength : </span>
                                            {
                                                validateUppercase ? 
                                                <span className="ml-4" style={{ fontSize: "12px", color: "green" }}>
                                                    <i className="fas fa-check-circle mr-2"></i>
                                                    Password harus memiliki setidaknya satu karakter huruf besar ( upper-case )
                                                </span>
                                                :
                                                <span className="ml-4" style={{ fontSize: "12px", color: "red" }}>
                                                    <i className="fas fa-times-circle mr-2"></i>
                                                    Password harus memiliki setidaknya satu karakter huruf besar ( upper-case )
                                                </span>
                                            }
                                            {
                                                validateLowercase ?
                                                <span className="ml-4" style={{ fontSize: "12px", color: "green" }}>
                                                    <i className="fas fa-check-circle mr-2"></i>
                                                    Password harus memiliki setidaknya satu karakter huruf kecil ( lower-case )
                                                </span>
                                                :
                                                <span className="ml-4" style={{ fontSize: "12px", color: "red" }}>
                                                    <i className="fas fa-times-circle mr-2"></i>
                                                    Password harus memiliki setidaknya satu karakter huruf kecil ( lower-case )
                                                </span>
                                            }
                                            {
                                                validateSpecialCharacter ? 
                                                <span className="ml-4" style={{ fontSize: "12px", color: "green" }}>
                                                    <i className="fas fa-check-circle mr-2"></i>
                                                    Password harus memiliki setidaknya satu karakter spesial ( #$@!&%... )
                                                </span>
                                                :
                                                <span className="ml-4" style={{ fontSize: "12px", color: "red" }}>
                                                    <i className="fas fa-times-circle mr-2"></i>
                                                    Password harus memiliki setidaknya satu karakter spesial ( #$@!&%... )
                                                </span>
                                            }
                                            {
                                                validateNumber ?
                                                <span className="ml-4" style={{ fontSize: "12px", color: "green" }}>
                                                    <i className="fas fa-check-circle mr-2"></i>
                                                    Password harus memiliki setidaknya satu angka
                                                </span>
                                                :
                                                <span className="ml-4" style={{ fontSize: "12px", color: "red" }}>
                                                    <i className="fas fa-times-circle mr-2"></i>
                                                    Password harus memiliki setidaknya satu angka
                                                </span>
                                            }
                                            {
                                                validateLenght ? 
                                                <span className="ml-4" style={{ fontSize: "12px", color: "green" }}>
                                                    <i className="fas fa-check-circle mr-2"></i>
                                                    Password harus memiliki panjang (length) lebih dari 5 karakter.
                                                </span>
                                                :
                                                <span className="ml-4" style={{ fontSize: "12px", color: "red" }}>
                                                    <i className="fas fa-times-circle mr-2"></i>
                                                    Password harus memiliki panjang (length) lebih dari 5 karakter.
                                                </span>
                                            }
                                    </div>
                                    : ''
                            }
                        </div>
                        <div className="modal-footer">
                            <button type="button" data-testid="widget-test" onClick={ widgetHandle } className="btn btn-info mr-auto">
                                <i className="fas fa-eye-dropper mr-1"></i>
                                Look`s Widget
                            </button>
                            <button type="button" data-testid="cancel-test" className="btn btn-secondary" data-dismiss="modal" onClick={ changePassList }>Cancel</button>
                            {
                                passwordManagement.update ?
                                <button type="button" data-testid="updatepass-test" className="btn btn-primary" onClick={ fireUpdatePass }>Update</button>
                                :
                                <button type="button" data-testid="savePass-test" className="btn btn-primary" onClick={ fireAddPass }>Save</button>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AddPass